/**
 * Runtime configuration sourced from Vite environment variables.
 * Set VITE_API_URL in your .env file or deployment environment.
 */
export const config = {
  /** Base URL for the survey API (no trailing slash) */
  apiBaseUrl: (import.meta.env.VITE_API_URL as string) || 'http://localhost:8080',
} as const
